import React, { FC } from 'react';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import SimpleBrandsSectionTitle from '../simpleBrands/customiseSectionTitle/CustomiseSectionTitle';
import FeatureSectionTitle from './featureSectionTitle/FeatureSectionTitle';
import { CustomiseCategoriesIds } from '../../../../../gqlCommon/constants/customiseCategoriesIds';
import TrimLevelType from '../../../../../trimLevels/enum/TrimLevelType';

export interface IFeatureSectionTitleContainerProps {
  label?: string;
  sectionCode: string;
  disclaimerIndicative?: string;
}

const FeatureSectionTitleContainer: FC<IFeatureSectionTitleContainerProps> = ({
  label,
  sectionCode,
  disclaimerIndicative,
}) => {
  const {
    platformConfig: { isComplexModel },
  } = usePlatformConfig();

  return (
    <>
      {isComplexModel && sectionCode !== TrimLevelType.VARIANT ? (
        <FeatureSectionTitle label={label} sectionCode={sectionCode} disclaimerIndicative={disclaimerIndicative} />
      ) : (
        <SimpleBrandsSectionTitle label={sectionCode} testId={CustomiseCategoriesIds[sectionCode] ?? sectionCode} />
      )}
    </>
  );
};

export default FeatureSectionTitleContainer;
